export const ZENDESK_AUTH_CHANNEL: string = 'zendesk-oauth';
export const ZENDESK_AUTH_CLOSE_MESSAGE: string = 'close';
